import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import {
    CATEGORY_ACCOUNT_DEBIT_VIA_IRELAND_PLAID,
    CATEGORY_ACCOUNT_DEBIT_VIA_MODULR,
    CATEGORY_ACCOUNT_DEBIT_VIA_PLAID,
    CATEGORY_TRANSFER_FROM_ACH,
    CATEGORY_TRANSFER_FROM_APPLE_PAY,
    CATEGORY_TRANSFER_FROM_APPLE_PAY_EEA,
    CATEGORY_TRANSFER_FROM_APPLE_PAY_EEA_DAC,
    CATEGORY_TRANSFER_FROM_APPLE_PAY_SV,
    CATEGORY_TRANSFER_FROM_APPLE_PAY_US,
    CATEGORY_TRANSFER_FROM_BANK_ACCOUNT,
    CATEGORY_TRANSFER_FROM_BANK_OFAKIM,
    CATEGORY_TRANSFER_FROM_BLIK,
    CATEGORY_TRANSFER_FROM_EPS,
    CATEGORY_TRANSFER_FROM_FLINKS,
    CATEGORY_TRANSFER_FROM_GIROPAY,
    CATEGORY_TRANSFER_FROM_GLOBAL_ACCOUNT,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY_EEA,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY_EEA_DAC,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY_SV,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY_US,
    CATEGORY_TRANSFER_FROM_IDEAL,
    CATEGORY_TRANSFER_FROM_INTERAC,
    CATEGORY_TRANSFER_FROM_LEAN,
    CATEGORY_TRANSFER_FROM_MBWAY,
    CATEGORY_TRANSFER_FROM_MYBANK,
    CATEGORY_TRANSFER_FROM_PAYPAL,
    CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC,
    CATEGORY_TRANSFER_FROM_SOFORT,
    CATEGORY_TRANSFER_FROM_KLARNA,
    CATEGORY_TRANSFER_FROM_TRUSTLY,
    CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT,
    PS_BONUS,
    CATEGORY_TRANSFER_FROM_TINK,
} from 'apps/auth/constants/Constants';
import { resolveArguments } from 'apps/auth/helpers/utils';

import CheckTableRow from './CheckTableRow';

const PaymentNumber = (props) => {
    const cheque = props.cheque;

    const getFromProviderTitle = (cheque, accountFrom) => {
        if (
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GOOGLE_PAY ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GOOGLE_PAY_EEA ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GOOGLE_PAY_US ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GOOGLE_PAY_EEA_DAC ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GOOGLE_PAY_SV
        ) {
            return resolveArguments(props.chequeFromGoogle, accountFrom);
        } else if (
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_APPLE_PAY ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_APPLE_PAY_SV ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_APPLE_PAY_EEA_DAC ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_APPLE_PAY_US ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_APPLE_PAY_EEA
        ) {
            return resolveArguments(props.chequeFromApple, accountFrom);
        } else if (
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_BANK_ACCOUNT ||
            cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT
        ) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_INTERAC) {
            return resolveArguments(props.chequeFromInterac, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC) {
            return resolveArguments(props.chequeFromPeopleTrustInterac, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_TRUSTLY) {
            return resolveArguments(props.chequeFromTrustly, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_TINK) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_FLINKS) {
            return resolveArguments(props.chequeFromFlinks, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_SOFORT) {
            return resolveArguments(props.chequeFromSofort, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_KLARNA) {
            return resolveArguments(props.chequeFromKlarna, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GIROPAY) {
            return resolveArguments(props.chequeFromSofort, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_ACH) {
            return resolveArguments(props.chequeFromSofort, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_LEAN) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_MYBANK) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.fromBalanceHolder === PS_BONUS) {
            return resolveArguments(props.chequeFromBonus, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_ACCOUNT_DEBIT_VIA_MODULR) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (
            cheque.providerFromCategory === CATEGORY_ACCOUNT_DEBIT_VIA_PLAID ||
            cheque.providerFromCategory === CATEGORY_ACCOUNT_DEBIT_VIA_IRELAND_PLAID
        ) {
            return cheque.fromPlaidBankName;
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_IDEAL) {
            return resolveArguments(props.chequeFromIdeal, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_BLIK) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_MBWAY) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_EPS) {
            return resolveArguments(props.chequeFromEps, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_GLOBAL_ACCOUNT) {
            return resolveArguments(props.chequeFromGlobalAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_BANK_OFAKIM) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_PAYPAL) {
            return resolveArguments(props.chequeFromSofort, accountFrom);
        } else {
            return resolveArguments(props.chequeFromCard, accountFrom);
        }
    };
    return (
        <>
            <Separator />
            <TableContainer>
                <CheckTableRow title={props.chequeFromCardHeader} cheque={cheque}>
                    {getFromProviderTitle(cheque, cheque.accountFrom)}
                </CheckTableRow>
                {(cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_INTERAC ||
                    cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC) && (
                    <CheckTableRow title={props.chequeFromInteracEmail} cheque={cheque}>
                        {cheque.accountFrom}
                    </CheckTableRow>
                )}
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    cheque: state.history.cheque.cheque,
    chequeFromCardHeader: state.messages.pageMessages.chequeFromCardHeader,
    chequeFromGoogle: state.messages.pageMessages.chequeFromGoogle,
    chequeFromInterac: state.messages.pageMessages.chequeFromInterac,
    chequeFromPeopleTrustInterac: state.messages.pageMessages.chequeFromPeopleTrustInterac,
    chequeFromGlobalAccount: state.messages.pageMessages.chequeFromGlobalAccount,
    chequeFromTrustly: state.messages.pageMessages.chequeFromTrustly,
    chequeFromFlinks: state.messages.pageMessages.chequeFromFlinks,
    chequeFromSofort: state.messages.pageMessages.chequeFromSofort,
    chequeFromKlarna: state.messages.pageMessages.chequeFromKlarna,
    chequeFromIdeal: state.messages.pageMessages.chequeFromIdeal,
    chequeFromBlik: state.messages.pageMessages.chequeFromBlik,
    chequeFromEps: state.messages.pageMessages.chequeFromEps,
    chequeFromMbway: state.messages.pageMessages.chequeFromMbway,
    chequeFromApple: state.messages.pageMessages.chequeFromApple,
    chequeFromBankAccount: state.messages.pageMessages.chequeFromBankAccount,
    chequeFromBonus: state.messages.pageMessages.chequeFromBonus,
    chequeFromCard: state.messages.pageMessages.chequeFromCard,
    chequeFromInteracEmail: state.messages.pageMessages.chequeFromInteracEmail,
});

export default connect(mapStateToProps)(PaymentNumber);
